import React, {useEffect, useState} from "react";
import {postbackApi} from "../../api/postbackApi";
import {
    Alert,
    Button,
    Card, Divider,
    FormControl,
    InputLabel, LinearProgress,
    MenuItem, Paper,
    Select,
    Stack,
    TextField,
    Typography
} from "@mui/material";
import {useFormik} from "formik";
import * as Yup from "yup";

const validationSchema = Yup.object({
    postbackUrl: Yup.string().required("Postback Url is required"),
    eventType: Yup.string().required("Event Type is required"),
    httpMethod: Yup.string().required("Http Method is required"),
});

const PostbackSimulator = () => {
    const [response, setResponse] = useState();
    const [alert, setAlert] = useState(null);
    const [testInProgress, setTestInProgress] = useState(false);
    const [testCompleted, setTestCompleted] = useState(false);
    const formik = useFormik({
        initialValues: {
            postbackUrl: '',
            eventType: '',
            v: '',
            v2: '',
            httpMethod: ''
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            setTestInProgress(true);
            setTestCompleted(false);
            setAlert(null);

            postbackApi.simulatePostback({
                postbackUrl: values.postbackUrl,
                eventType: values.eventType,
                v: values.v,
                v2: values.v2,
                httpMethod: values.httpMethod
            }).then(r => {
                setTestInProgress(false);
                setTestCompleted(true);
                setResponse(r);
            }).catch(r => {
                setAlert(<Alert severity="error">{r.response.data.message}</Alert>)
                setTestInProgress(false);
            })
        }
    });

    return <>
        { alert }
        <Card sx={{ p: 2 }}>
            <Stack direction='column' spacing={2}>
                <Typography>Test Your Postback Configuration</Typography>
                <TextField
                    fullWidth
                    label='Postback Url'
                    name="postbackUrl"
                    value={formik.values.postbackUrl}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.postbackUrl && Boolean(formik.errors.postbackUrl)}
                    helperText={formik.touched.postbackUrl && formik.errors.postbackUrl}
                />
                <Stack direction='row' spacing={2}>
                    <FormControl fullWidth>
                        <InputLabel id="select-label-1">Event Type</InputLabel>
                        <Select
                            labelId="select-label-1"
                            label="Event Type"
                            name="eventType"
                            value={formik.values.eventType}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.eventType && Boolean(formik.errors.eventType)}
                            helperText={formik.touched.eventType && formik.errors.eventType}
                        >
                            <MenuItem value={'REGISTRATION'}>REGISTRATION</MenuItem>
                            <MenuItem value={'FTD'}>FTD</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl fullWidth>
                        <InputLabel id="select-label-2">HTTP Method</InputLabel>
                        <Select
                            labelId="select-label-2"
                            label="HTTP Method"
                            name="httpMethod"
                            value={formik.values.httpMethod}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.httpMethod && Boolean(formik.errors.httpMethod)}
                            helperText={formik.touched.httpMethod && formik.errors.httpMethod}
                        >
                            <MenuItem value={'GET'}>GET</MenuItem>
                            <MenuItem value={'POST'}>POST</MenuItem>
                        </Select>
                    </FormControl>
                </Stack>
                <Stack direction='row' spacing={2}>
                    <TextField
                        fullWidth
                        label='V'
                        name="v"
                        value={formik.values.v}
                        onChange={formik.handleChange}
                    />
                    <TextField
                        fullWidth
                        label='V2'
                        name="v2"
                        value={formik.values.v2}
                        onChange={formik.handleChange}
                    />
                </Stack>
                <Button variant='outlined' onClick={formik.submitForm}>Test Request</Button>
                <Divider sx={{ mt: 4, mb: 4 }}/>
                { testInProgress
                    ? <LinearProgress />
                    : testCompleted && response && <TestResponse response={response}/>
                }
            </Stack>
        </Card>
    </>
}

const TestResponse = ({ response }) => {
    return <Paper sx={{ p: 4 }}>
        <Stack direction='column' spacing={2}>
            <Typography>
                Test Results
            </Typography>
            <Divider sx={{ mb: 4 }}/>
            <Typography>
                Request was send to : <code>{response.postbackUrl}</code>
            </Typography>
            <Typography>
                Response status code : {response.statusCode}
            </Typography>
        </Stack>
    </Paper>
}

export default PostbackSimulator;
